import { cn } from '~/lib/utils'
import FeatureItem, { FeatureItemProps } from '../FeatureItem/FeatureItem'

type FeatureListProps = {
  content: {
    items: Array<FeatureItemProps['content']>
    eyebrow: string
  }
  backgroundColour?: AllBackgroundColours
  layoutColour?: AllBackgroundColours
  alignment?: 'left' | 'centre'
  canvas?: boolean
}

const FeatureList = ({
  content,
  backgroundColour,
  layoutColour,
  alignment = 'left'
}: FeatureListProps) => {
  const { items, eyebrow } = content

  return (
    <div
      className={cn(
        'sm:gap-m gap-s flex max-w-[85ch] flex-col',
        alignment === 'centre' ? 'mx-auto text-left' : ''
      )}
    >
      {eyebrow && <div className='tag'>{eyebrow}</div>}
      <div className='gap-y-m flex flex-col'>
        {items?.map((item, index: Index) => (
          <FeatureItem
            key={index}
            content={item}
            layoutColour={backgroundColour || layoutColour}
          />
        ))}
      </div>
    </div>
  )
}

export default FeatureList
